import Modal from "@/components/common/modal/Modal";
import Input from "@/components/common/input/Input";
import Button from "@/components/common/button/Button";
import DataSelect from "@/components/common/select/DataSelect";
import AlertMessage from "@/components/layout/message/AlertMessage";
import styles from "./FormModal.module.css";
import type { simulationFormModalProps } from "./types.props";
import { useSimulationForm } from "./useSimulationFormModal";
import { useEffect } from "react";

const STATES_OPTIONS = [
    { value: "in_design", label: "En diseño" },
    { value: "published", label: "Publicado" },
    { value: "closed", label: "Cerrado" },
];

const TYPE_OPTIONS = [
    { value: "presencial", label: "Presencial" },
    { value: "virtual", label: "Virtual" },
];

const SimulationFormModal: React.FC<simulationFormModalProps> = ({
    isOpen,
    isLoading,
    initialData,
    apiError,
    onClose,
    onSubmit,
}) => {
    const {
        formData,
        formErrors,
        setFormErrors,
        isEditMode,
        handleInputChange,
        validateForm,
    } = useSimulationForm(initialData);

    useEffect(() => {
        if (apiError) {
            setFormErrors(apiError);
        }
    }, [apiError, setFormErrors]);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (validateForm()) {
            onSubmit(formData);
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <form onSubmit={handleSubmit} className={styles["form"]}>
                <h2 className={styles["form-title"]}>
                    {isEditMode ? "Modificar simulacro" : "Añadir simulacro"}
                </h2>

                <Input
                    id="name"
                    name="name"
                    label="Nombre del simulacro"
                    value={formData.name}
                    onChange={handleInputChange}
                    error={formErrors?.fieldErrors?.name}
                    required
                    autoFocus
                />
                <Input
                    id="description"
                    name="description"
                    label="Descripción"
                    value={formData.description}
                    onChange={handleInputChange}
                    error={formErrors?.fieldErrors?.description}
                />
                <div className={styles["form-grid"]}>
                    <DataSelect
                        name="type"
                        label="Modalidad"
                        value={formData.type}
                        onChange={handleInputChange}
                        error={formErrors?.fieldErrors?.type}
                        options={TYPE_OPTIONS}
                        required
                    />
                    <DataSelect
                        name="state"
                        label="Estado"
                        value={formData.state}
                        onChange={handleInputChange}
                        error={formErrors?.fieldErrors?.state}
                        options={STATES_OPTIONS}
                        required
                    />
                </div>

                <AlertMessage type="error" title="Error en el formulario">
                    {formErrors?.generalMessage}
                </AlertMessage>

                <div className={styles["form-actions"]}>
                    <Button type="button" variant="secondary" onClick={onClose}>
                        Cancelar
                    </Button>
                    <Button type="submit" variant="primary" isLoading={isLoading}>
                        {isEditMode ? "Actualizar" : "Crear simulacro"}
                    </Button>
                </div>
            </form>
        </Modal>
    );
};

export default SimulationFormModal;
